<template>
  <div>
    <van-form @submit="onSubmit()">
      <van-field
        v-model="params.name"
        name="用户名"
        label="用户名"
        placeholder="用户名"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
        v-model="params.password"
        type="password"
        name="密码"
        label="密码"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit" @click="onSubmit()"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import {
  setToken,
  getToken
} from '@/utils/cookies'
export default {
  name: 'LoginView',
  data () {
    return {
      params: {
        name: 'test001',
        password: '123456aa',
        type: '1'
      }
    }
  },
  mounted(){
    if (getToken()) {
      this.$router.push({ name: 'home' })
      return
    }
  },
  methods: {
    async onSubmit () {
      alert()
      await this.$http({
        method: 'post',
        url: 'login',
        data: this.params
      }).then(data => {
        setToken(data.data.api_token)
        location.reload()
      })
    }
  }
}
</script>

<style></style>
